export default "__VITE_ASSET__B5dXg049__"